import Settings from '.'

const routes = [
	{
		path: '/settings',
		component: Settings,
	},
]

export default routes
